import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheckIcon, HeartIcon, ClockIcon, CheckCircle2Icon, ArrowRightIcon, StarIcon } from 'lucide-react';
export function MarketingLandingPage() {
  return <div className="min-h-screen bg-white font-sans text-[#0B1220] flex flex-col" data-id="element-4070">
      {/* Sticky Header */}
      <header className="sticky top-0 z-50 bg-white border-b border-gray-100 shadow-sm" data-id="element-4071">
        <div className="max-w-7xl mx-auto px-4 md:px-6 h-16 flex items-center justify-between" data-id="element-4072">
          <Link to="/marketing" className="flex-shrink-0" data-id="element-4073">
            <img src="https://cdn.magicpatterns.com/uploads/u2RsmpFkExbV8oAVAJrtqh/Caveo-Lockup-FC.png" alt="Caveo" className="h-6 md:h-7" data-id="element-4074" />
          </Link>
          <Link to="/onboarding" className="bg-[#0EB4CC] text-white px-5 py-2.5 rounded-full font-bold text-sm hover:bg-[#0ca3b8] transition-colors shadow-sm" data-id="element-4075">
            Get Started
          </Link>
        </div>
      </header>

      <main className="flex-1 flex flex-col" data-id="element-4076">
        {/* Hero Section */}
        <section className="bg-[#FFF1D3] px-4 py-16 md:py-24 relative overflow-hidden" data-id="element-4077">
          <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-4078">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-[#1F0648] mb-6 leading-[1.1] tracking-tight" data-id="element-4079">
              Your parents deserve better than a frustrated family IT guy.
            </h1>
            <p className="text-lg md:text-xl text-[#0B1220] mb-8 leading-relaxed max-w-2xl mx-auto opacity-90" data-id="element-4080">
              Caveo is the first digital safety platform that actually teaches
              your parents how to stay safe online, so you can stop fixing their
              Wi-Fi and start enjoying your weekends again.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-4081">
              <Link to="/onboarding" className="w-full sm:w-auto bg-[#1F0648] text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-[#2d096b] transition-all shadow-lg flex items-center justify-center gap-2" data-id="element-4082">
                Start free 7-day trial
                <ArrowRightIcon size={20} data-id="element-4083" />
              </Link>
              <p className="text-sm text-[#1F0648] font-medium opacity-75 sm:hidden mt-2" data-id="element-4084">
                No credit card required
              </p>
            </div>
            <div className="hidden sm:flex items-center justify-center gap-2 mt-6 text-sm text-[#1F0648] font-medium opacity-80" data-id="element-4085">
              <CheckCircle2Icon size={16} className="text-[#0EB4CC]" data-id="element-4086" /> Cancel
              anytime
              <span className="mx-2" data-id="element-4087">•</span>
              <CheckCircle2Icon size={16} className="text-[#0EB4CC]" data-id="element-4088" /> Takes 3
              minutes
            </div>
          </div>

          {/* Decorative background elements */}
          <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-4089">
            <div className="absolute -top-24 -right-24 w-64 h-64 bg-[#0EB4CC] rounded-full mix-blend-multiply filter blur-3xl opacity-20" data-id="element-4090"></div>
            <div className="absolute -bottom-24 -left-24 w-64 h-64 bg-[#1F0648] rounded-full mix-blend-multiply filter blur-3xl opacity-10" data-id="element-4091"></div>
          </div>
        </section>

        {/* Benefits Section */}
        <section className="bg-white px-4 py-16 md:py-24" data-id="element-4092">
          <div className="max-w-7xl mx-auto" data-id="element-4093">
            <div className="text-center max-w-2xl mx-auto mb-12 md:mb-16" data-id="element-4094">
              <h2 className="text-3xl md:text-4xl font-bold text-[#1F0648] mb-4" data-id="element-4095">
                Peace of mind for them. Time back for you.
              </h2>
              <p className="text-[#0B1220] opacity-80 text-lg" data-id="element-4096">
                We replace confusing tech jargon with plain-English guidance
                that builds genuine digital confidence.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-4097">
              {/* Benefit 1 */}
              <div className="bg-[#f8f9fa] rounded-2xl p-8 border border-gray-100 shadow-sm hover:shadow-md transition-shadow" data-id="element-4098">
                <div className="w-14 h-14 bg-[#FFF1D3] rounded-xl flex items-center justify-center mb-6" data-id="element-4099">
                  <ShieldCheckIcon size={28} className="text-[#1F0648]" data-id="element-4100" />
                </div>
                <h3 className="text-xl font-bold text-[#1F0648] mb-3" data-id="element-4101">
                  Stop the Scams
                </h3>
                <p className="text-[#0B1220] opacity-80 leading-relaxed" data-id="element-4102">
                  Proactive education helps your parents spot phishing, fake
                  alerts, and social engineering before they click.
                </p>
              </div>

              {/* Benefit 2 */}
              <div className="bg-[#f8f9fa] rounded-2xl p-8 border border-gray-100 shadow-sm hover:shadow-md transition-shadow" data-id="element-4103">
                <div className="w-14 h-14 bg-[#FFF1D3] rounded-xl flex items-center justify-center mb-6" data-id="element-4104">
                  <ClockIcon size={28} className="text-[#1F0648]" data-id="element-4105" />
                </div>
                <h3 className="text-xl font-bold text-[#1F0648] mb-3" data-id="element-4106">
                  Reclaim Your Time
                </h3>
                <p className="text-[#0B1220] opacity-80 leading-relaxed" data-id="element-4107">
                  No more emergency tech support calls during dinner. We handle
                  the repetitive questions so you don't have to.
                </p>
              </div>

              {/* Benefit 3 */}
              <div className="bg-[#f8f9fa] rounded-2xl p-8 border border-gray-100 shadow-sm hover:shadow-md transition-shadow" data-id="element-4108">
                <div className="w-14 h-14 bg-[#FFF1D3] rounded-xl flex items-center justify-center mb-6" data-id="element-4109">
                  <HeartIcon size={28} className="text-[#1F0648]" data-id="element-4110" />
                </div>
                <h3 className="text-xl font-bold text-[#1F0648] mb-3" data-id="element-4111">
                  Built for Boomers
                </h3>
                <p className="text-[#0B1220] opacity-80 leading-relaxed" data-id="element-4112">
                  Zero jargon. No downloads required. Just clear, step-by-step
                  guidance designed specifically for older adults.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* How It Works */}
        <section className="bg-[#1F0648] px-4 py-16 md:py-24 text-white" data-id="element-4113">
          <div className="max-w-7xl mx-auto" data-id="element-4114">
            <div className="text-center max-w-2xl mx-auto mb-12 md:mb-16" data-id="element-4115">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-4116">
                How Caveo works
              </h2>
              <p className="text-gray-300 text-lg" data-id="element-4117">
                A simple, dignified approach to digital safety.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-4118">
              {/* Connecting line for desktop */}
              <div className="hidden md:block absolute top-8 left-[15%] right-[15%] h-0.5 bg-[#2d096b] z-0" data-id="element-4119"></div>

              <div className="relative z-10 flex flex-col items-center text-center" data-id="element-4120">
                <div className="w-16 h-16 bg-[#0EB4CC] rounded-full flex items-center justify-center text-2xl font-bold text-white mb-6 shadow-lg border-4 border-[#1F0648]" data-id="element-4121">
                  1
                </div>
                <h3 className="text-xl font-bold text-white mb-3" data-id="element-4122">
                  Take the Assessment
                </h3>
                <p className="text-gray-300 leading-relaxed" data-id="element-4123">
                  A quick 3-minute quiz identifies your family's specific
                  vulnerabilities and current tech setup.
                </p>
              </div>

              <div className="relative z-10 flex flex-col items-center text-center" data-id="element-4124">
                <div className="w-16 h-16 bg-[#0EB4CC] rounded-full flex items-center justify-center text-2xl font-bold text-white mb-6 shadow-lg border-4 border-[#1F0648]" data-id="element-4125">
                  2
                </div>
                <h3 className="text-xl font-bold text-white mb-3" data-id="element-4126">
                  Get a Custom Plan
                </h3>
                <p className="text-gray-300 leading-relaxed" data-id="element-4127">
                  We generate a personalized curriculum focused only on what
                  they actually need to know.
                </p>
              </div>

              <div className="relative z-10 flex flex-col items-center text-center" data-id="element-4128">
                <div className="w-16 h-16 bg-[#0EB4CC] rounded-full flex items-center justify-center text-2xl font-bold text-white mb-6 shadow-lg border-4 border-[#1F0648]" data-id="element-4129">
                  3
                </div>
                <h3 className="text-xl font-bold text-white mb-3" data-id="element-4130">
                  Learn & Secure
                </h3>
                <p className="text-gray-300 leading-relaxed" data-id="element-4131">
                  They complete bite-sized, jargon-free lessons that build real
                  confidence and secure their accounts.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Testimonials */}
        <section className="bg-[#FFF1D3] px-4 py-16 md:py-24" data-id="element-4132">
          <div className="max-w-7xl mx-auto" data-id="element-4133">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1F0648] text-center mb-12" data-id="element-4134">
              Loved by families
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-4135">
              <div className="bg-white p-8 rounded-2xl shadow-sm" data-id="element-4136">
                <div className="flex gap-1 mb-4 text-[#0EB4CC]" data-id="element-4137">
                  <StarIcon size={20} fill="currentColor" data-id="element-4138" />
                  <StarIcon size={20} fill="currentColor" data-id="element-4139" />
                  <StarIcon size={20} fill="currentColor" data-id="element-4140" />
                  <StarIcon size={20} fill="currentColor" data-id="element-4141" />
                  <StarIcon size={20} fill="currentColor" data-id="element-4142" />
                </div>
                <p className="text-[#0B1220] italic mb-6 leading-relaxed" data-id="element-4143">
                  "My dad almost lost $4,000 to a phishing scam last year. Since
                  starting Caveo, he actually understands what to look for. And
                  the best part? He hasn't called me to fix his iPad in two
                  months."
                </p>
                <div className="flex items-center gap-3" data-id="element-4144">
                  <div className="w-10 h-10 bg-[#1F0648] rounded-full flex items-center justify-center text-white font-bold" data-id="element-4145">
                    S
                  </div>
                  <div data-id="element-4146">
                    <p className="font-bold text-[#1F0648]" data-id="element-4147">Sarah M.</p>
                    <p className="text-sm text-gray-500" data-id="element-4148">
                      Daughter & "Family IT Dept"
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-white p-8 rounded-2xl shadow-sm" data-id="element-4149">
                <div className="flex gap-1 mb-4 text-[#0EB4CC]" data-id="element-4150">
                  <StarIcon size={20} fill="currentColor" data-id="element-4151" />
                  <StarIcon size={20} fill="currentColor" data-id="element-4152" />
                  <StarIcon size={20} fill="currentColor" data-id="element-4153" />
                  <StarIcon size={20} fill="currentColor" data-id="element-4154" />
                  <StarIcon size={20} fill="currentColor" data-id="element-4155" />
                </div>
                <p className="text-[#0B1220] italic mb-6 leading-relaxed" data-id="element-4156">
                  "I was skeptical that an app could teach my 72-year-old mom
                  about password managers, but the plain-English approach really
                  works. It treats her with dignity instead of talking down to
                  her."
                </p>
                <div className="flex items-center gap-3" data-id="element-4157">
                  <div className="w-10 h-10 bg-[#0EB4CC] rounded-full flex items-center justify-center text-white font-bold" data-id="element-4158">
                    M
                  </div>
                  <div data-id="element-4159">
                    <p className="font-bold text-[#1F0648]" data-id="element-4160">Michael T.</p>
                    <p className="text-sm text-gray-500" data-id="element-4161">Son & Caregiver</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Pricing Teaser / Final CTA */}
        <section className="bg-white px-4 py-16 md:py-24 text-center" data-id="element-4162">
          <div className="max-w-3xl mx-auto" data-id="element-4163">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1F0648] mb-6" data-id="element-4164">
              Protect your family today
            </h2>
            <p className="text-lg text-[#0B1220] opacity-80 mb-8 max-w-xl mx-auto" data-id="element-4165">
              Get comprehensive digital safety education for the whole family
              for less than the cost of one tech support visit.
            </p>

            <div className="bg-[#f8f9fa] rounded-2xl p-8 max-w-md mx-auto border border-gray-200 mb-8" data-id="element-4166">
              <h3 className="text-2xl font-bold text-[#1F0648] mb-2" data-id="element-4167">
                Family Plan
              </h3>
              <div className="flex items-end justify-center gap-1 mb-6" data-id="element-4168">
                <span className="text-4xl font-extrabold text-[#0B1220]" data-id="element-4169">
                  $19.99
                </span>
                <span className="text-gray-500 mb-1" data-id="element-4170">/month</span>
              </div>
              <ul className="text-left space-y-3 mb-8" data-id="element-4171">
                <li className="flex items-center gap-3 text-[#0B1220]" data-id="element-4172">
                  <CheckCircle2Icon size={20} className="text-[#0EB4CC] shrink-0" data-id="element-4173" />
                  <span data-id="element-4174">Up to 5 family members</span>
                </li>
                <li className="flex items-center gap-3 text-[#0B1220]" data-id="element-4175">
                  <CheckCircle2Icon size={20} className="text-[#0EB4CC] shrink-0" data-id="element-4176" />
                  <span data-id="element-4177">Full curriculum access</span>
                </li>
                <li className="flex items-center gap-3 text-[#0B1220]" data-id="element-4178">
                  <CheckCircle2Icon size={20} className="text-[#0EB4CC] shrink-0" data-id="element-4179" />
                  <span data-id="element-4180">Family dashboard & alerts</span>
                </li>
              </ul>
              <Link to="/onboarding" className="block w-full bg-[#0EB4CC] text-white px-6 py-4 rounded-full font-bold text-lg hover:bg-[#0ca3b8] transition-colors shadow-md" data-id="element-4181">
                Start 7-Day Free Trial
              </Link>
            </div>
            <p className="text-sm text-gray-500" data-id="element-4182">
              Cancel anytime. No commitment.
            </p>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="bg-[#1F0648] text-white py-12 px-4 border-t border-[#2d096b]" data-id="element-4183">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-4184">
          <div className="flex items-center gap-2" data-id="element-4185">
            <img src="https://cdn.magicpatterns.com/uploads/ddFjEWvaDfXw4mBqdFC5Gd/Caveo_Logotype_Horizontal_240x50_White_PNG.png" alt="Caveo" className="h-6 opacity-90" data-id="element-4186" />
          </div>
          <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-400" data-id="element-4187">
            <Link to="/about-us" className="hover:text-white transition-colors" data-id="element-4188">
              About
            </Link>
            <Link to="/pricing" className="hover:text-white transition-colors" data-id="element-4189">
              Pricing
            </Link>
            <Link to="/privacy" className="hover:text-white transition-colors" data-id="element-4190">
              Privacy Policy
            </Link>
          </div>
          <div className="text-sm text-gray-500" data-id="element-4191">
            &copy; {new Date().getFullYear()} Caveo. All rights reserved.
          </div>
        </div>
      </footer>
    </div>;
}